import React, { useEffect } from 'react';
import { useResultStore } from '@components/acca/results/result/resultStoreProvider';
import { GameType, gameTypeStringMap } from '@domain/constant/acca/test/result/gameType';
import classnames from 'classnames/bind';
import styles from './gameTab.module.scss';

const cx = classnames.bind(styles);

interface GameTabProps {
  gameTab: GameType;
  setGameTab: (gameTab: GameType) => void;
}

const GameTab = ({ gameTab, setGameTab }: GameTabProps) => {
  const { accaResultStore } = useResultStore();
  const { accGameResult } = accaResultStore;

  useEffect(() => {
    if (accGameResult?.details?.length) {
      setGameTab(accGameResult.details[0].type);
    }
  }, [accGameResult]);

  if (!accGameResult) return null;

  const { details } = accGameResult;

  const tabItemEl = details?.map((detail, index) => {
    const { type, unreliableYn } = detail;
    const isOn = gameTab === type;
    const handleClick = () => setGameTab(type);

    return (
      <a
        key={index}
        className={cx('btnTab', { on: isOn }, { warning: unreliableYn })}
        onClick={handleClick}
        role="button"
      >
        {gameTypeStringMap[type]}
      </a>
    );
  });

  return (
    <div className={cx('tabArea')}>
      <div className={cx('tabWrap')}>{tabItemEl}</div>
    </div>
  );
};

export default GameTab;
